import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditExecutionTimes',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      weekDayOptions: [{
        value: this.$i18n_t('Common.AllDays'),
        text: this.$i18n_t('Common.AllDays')
      }, {
        value: 1,
        text: this.$i18n_t('Common.Monday')
      }, {
        value: 2,
        text: this.$i18n_t('Common.Tuesday')
      }, {
        value: 3,
        text: this.$i18n_t('Common.Wednesday')
      }, {
        value: 4,
        text: this.$i18n_t('Common.Thursday')
      }, {
        value: 5,
        text: this.$i18n_t('Common.Friday')
      }, {
        value: 6,
        text: this.$i18n_t('Common.Saturday')
      }, {
        value: 0,
        text: this.$i18n_t('Common.Sunday')
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || parseInt(v) === 0 || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    hourRules: function hourRules() {
      var _this2 = this;

      return [].concat(_toConsumableArray(this.requiredRule), [function (v) {
        return v >= 0 && v <= 23 || _this2.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRule');
      }]);
    },
    minuteRules: function minuteRules() {
      var _this3 = this;

      return [].concat(_toConsumableArray(this.requiredRule), [function (v) {
        return v >= 0 && v <= 59 || _this3.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.minuteRule');
      }]);
    },
    executionTimes: function executionTimes() {
      return (get(this.rule, 'properties.executionTimes') || []).filter(function (t) {
        return !!get(t, 'startTime') && t.startTime.constructor === Object;
      });
    },
    hourRuleEveryX: function hourRuleEveryX() {
      var _this4 = this;

      return [].concat(_toConsumableArray(this.requiredRule), [function (v) {
        return v > 0 || _this4.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRuleEveryX');
      }]);
    },
    monthDaysOptions: function monthDaysOptions() {
      var monthDays = Array.from({
        length: 31
      }, function (idx, i) {
        return i + 1;
      });
      monthDays.unshift(this.$i18n_t('Common.AllDays'));
      return monthDays;
    }
  }),
  methods: {
    startDatePicked: function startDatePicked(dateObject, i) {
      this.rule.properties.executionTimes[i].dateStart = new Date(dateObject.from * 1000).toISOString();
      this.refreshExecutionTimes();
    },
    endDatePicked: function endDatePicked(dateObject, i) {
      this.rule.properties.executionTimes[i].dateEnd = new Date(dateObject.from * 1000).toISOString();
      this.refreshExecutionTimes();
    },
    refreshExecutionTimes: function refreshExecutionTimes() {
      this.$emit('refresh-form');
    },
    handleDaysSelection: function handleDaysSelection(executionIndex, property) {
      var _this5 = this;

      var days = this.executionTimes[executionIndex][property] || [];

      if (days.includes(this.$i18n_t('Common.AllDays'))) {
        if (days.indexOf(this.$i18n_t('Common.AllDays')) === days.length - 1) {
          this.rule.properties.executionTimes[executionIndex][property] = [this.$i18n_t('Common.AllDays')];
        } else {
          this.rule.properties.executionTimes[executionIndex][property] = days.filter(function (day) {
            return day !== _this5.$i18n_t('Common.AllDays');
          });
        }
      }
    }
  }
};